import { Tab, TabList, TabPanel, Tabs } from "@mui/joy";
import React from "react";
import TicketListing from "./TicketListing";
import { SxProps } from "@mui/joy/styles/types";
import { useLocation } from "react-router-dom";
import InspectionsList from "./InspectionsList";

interface InspectionPortalProps {
	selected: number;
}
export default function InspectionPortal(props: InspectionPortalProps) {
	const [idx, setIdx] = React.useState(props.selected);
	const location = useLocation();
	React.useEffect(() => {
		const paths = ["1year", "5year", "companies"];
		const x = location.pathname.toLowerCase().replace("/", "");
		const i = paths.indexOf(x);
		if (i > -1) {
			setIdx(i);
		}
	}, [location]);
	const tabSx = { backgroundColor: "initial !important" } as SxProps;
	return (
		<Tabs value={idx} onChange={(event, value) => setIdx(value as number)}>
			<TabList>
				<Tab color={idx === 0 ? "primary" : "neutral"} sx={tabSx}>
					Annual
				</Tab>
				<Tab color={idx === 1 ? "primary" : "neutral"} sx={tabSx}>
					5 Year
				</Tab>
				<Tab color={idx === 2 ? "primary" : "neutral"} sx={tabSx}>
					Alterations
				</Tab>
				{/* <Tab color={idx === 3 ? "primary" : "neutral"} sx={tabSx}>
					Company Setups
				</Tab> */}
			</TabList>
			<TabPanel value={0}>
				<InspectionsList annual={true} alterations={false} />
			</TabPanel>
			<TabPanel value={1}>
				<InspectionsList annual={false} alterations={false} />
			</TabPanel>
			<TabPanel value={2}>
				<InspectionsList annual={false} alterations={true} />
			</TabPanel>
			{/* <TabPanel value={3}>
				<TicketListing ticketTypesId="9D13704F-808B-4267-A35F-245C7CB26D8D" />
			</TabPanel> */}
		</Tabs>
	);
}

